import { Phone, ClipboardList, Stethoscope, HeartHandshake } from "lucide-react";

const steps = [
  {
    icon: Phone,
    title: "1. Primeiro Contato",
    desc: "Fale conosco pelo WhatsApp ou telefone. Nossa equipe escuta sua história e entende suas necessidades.",
  },
  {
    icon: ClipboardList,
    title: "2. Avaliação Personalizada",
    desc: "Ajudamos a encontrar clínicas compatíveis com o perfil do paciente, localização e orçamento.",
  },
  {
    icon: Stethoscope,
    title: "3. Início do Tratamento",
    desc: "Equipe multidisciplinar elabora um plano terapêutico individualizado com acompanhamento 24h.",
  },
  {
    icon: HeartHandshake,
    title: "4. Acompanhamento Contínuo",
    desc: "Suporte familiar, prevenção de recaídas e orientação pós-tratamento para uma recuperação duradoura.",
  },
];

export default function LandingProcess() {
  return (
    <section className="max-w-5xl mx-auto px-4 py-12">
      <h2 className="text-2xl font-bold text-foreground text-center mb-2">
        Como Funciona o Processo de Recuperação?
      </h2>
      <p className="text-muted-foreground text-center text-sm mb-10">
        Do primeiro contato à reintegração social — acompanhamos cada etapa
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps.map((s) => (
          <div key={s.title} className="relative flex flex-col items-center text-center gap-3">
            <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
              <s.icon className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-sm font-semibold text-foreground">{s.title}</h3>
            <p className="text-xs text-muted-foreground leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
